<template>
	<div>
		<div v-for="key of keys" :key="key">
			<div class="flex">
				<div class="fw6 c1 mr2 lh150">{{ key }}</div>
				<div v-if="typeof object[key] !== 'object'" class="lh150">
					{{ object[key] }}
				</div>
				<div v-else>
					<endorsements-data-item-array
						v-if="Array.isArray(object[key])"
						:array="object[key]"
						>{{ object[key] }}</endorsements-data-item-array
					>
					<endorsements-data-item-object
						class="bb1 bc7"
						v-else
						:object="object[key]"
						>{{ object[key] }}</endorsements-data-item-object
					>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "EndorsementsDataItemObject",
	props: ["object"],
	components: {
		EndorsementsDataItemArray: () => import("./EndorsementsDataItemArray"),
		EndorsementsDataItemObject: () => import("./EndorsementsDataItemObject")
	},

	data() {
		return {
			keys: Object.keys(this.object)
		}
	}
}
</script>
